import React from "react";
import styled from "styled-components";
import FadeInContent from "../components/FadeInContent";
import BraipConfig from "../components/Braip/BraipConfig";
import BraipStats from "../components/Braip/BraipStats";
import BraipWebhookHistory from "../components/Braip/BraipWebhookHistory";
import BraipProducts from "../components/Braip/BraipProducts";
import { SkeletonLoader } from "../components/SkeletonLoader";
import { useCurrentUser } from "../hooks/useCurrentUser";
import { useBraipData } from "../hooks/useBraip";
import { useSkeletonDelay } from "../hooks/useSkeletonDelay";

const BraipContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing[6]};
`;

const BraipHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${props => props.theme.spacing[4]};
`;

const BraipTitle = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing[4]};
`;

const BraipInfo = styled.div`
  flex: 1;
`;

const BraipName = styled.h1`
  font-family: ${props => props.theme.typography.fontFamily.heading};
  font-size: ${props => props.theme.typography.fontSize['4xl']};
  font-weight: ${props => props.theme.typography.fontWeight.bold};
  color: ${props => props.theme.colors.textPrimary};
  margin: 0 0 ${props => props.theme.spacing[2]} 0;
  background: none;
  -webkit-background-clip: initial;
  -webkit-text-fill-color: initial;
  background-clip: initial;
`;

const BraipDescription = styled.p`
  font-size: ${props => props.theme.typography.fontSize.lg};
  color: ${props => props.theme.colors.textSecondary};
  margin: 0;
`;

const Braip: React.FC = () => {
  const { user } = useCurrentUser();
  const userId = user?.uid;
  const { isLoading } = useBraipData(userId);
  const showSkeleton = useSkeletonDelay(isLoading, 800);

  if (showSkeleton) {
    return <SkeletonLoader variant="braip" />;
  }

  return (
    <FadeInContent>
      <BraipContainer>
        <BraipHeader>
          <BraipTitle>
            <BraipInfo>
              <BraipName>Braip</BraipName>
              <BraipDescription>
                Integração com a plataforma Braip
              </BraipDescription>
            </BraipInfo>
          </BraipTitle>
        </BraipHeader>

        {/* Configuração da integração */}
        <BraipConfig userId={userId} />

        {/* Estatísticas */}
        <BraipStats userId={userId} />

        {/* Histórico de Webhooks */}
        <BraipWebhookHistory userId={userId} limit={50} />

        {/* Produtos (preparado para futuro) */}
        <BraipProducts />
      </BraipContainer>
    </FadeInContent>
  );
};

export default Braip;
